import { z } from "zod";

export const NewsletterSubscriptionFormSchema = z.object({
  name: z.string().min(1, "Bitte gib deinen Namen ein."),
  mail: z.email({ message: "Bitte gib eine gültige E-Mail-Adresse ein." }),
  // Brevo contact list id, supplied by the Storyblok blok. Intentionally NOT
  // constrained to a code-side allowlist: marketing creates lists in Brevo and
  // wires them up in Storyblok, and that must not require a code change and
  // deploy. See brevo-and-email-marketing.md § "List ids are content, not code".
  includeListId: z.string(),
  // Optional client hint for the post-confirmation landing page. The server
  // re-validates this value against an allowlist of trusted website origins
  // before forwarding it to Brevo's DOI flow to prevent the confirmation
  // email from being weaponized as an open redirect to a phishing page.
  redirectionUrl: z.string().optional(),
});

export type NewsletterSubscriptionFormBody = z.infer<typeof NewsletterSubscriptionFormSchema>;

export type NewsletterSubscriptionFormResponse = "created" | "updated";
